var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.911,
    height: 18.099,
    viewBox: "0 0 24.911 18.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-youtube",
    "data-name": "Icon feather-youtube",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7900",
    "data-name": "Path 7900",
    d: "M23.93,8.52a2.9,2.9,0,0,0-2.02-2.083C20.119,6,12.954,6,12.954,6S5.79,6,4,6.479a2.9,2.9,0,0,0-2.02,2.083A30.2,30.2,0,0,0,1.5,14.07a30.2,30.2,0,0,0,.479,5.55,2.9,2.9,0,0,0,2.02,2c1.791.479,8.955.479,8.955.479s7.164,0,8.955-.479a2.9,2.9,0,0,0,2.02-2.083,30.2,30.2,0,0,0,.479-5.467,30.2,30.2,0,0,0-.479-5.55Z",
    transform: "translate(-1.499 -6)",
    fill: "none",
    stroke: "#3254fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7901",
    "data-name": "Path 7901",
    d: "M14.625,19.53l5.988-3.405L14.625,12.72Z",
    transform: "translate(-5.513 -8.055)",
    fill: "none",
    stroke: "#3254fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4759045157e069288a0f850896811c3e.svg";
export { ForwardRef as ReactComponent };